import { c as _c } from "react/compiler-runtime";
import { Avatar } from '@systemeio/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface AffiliateDashboardVendorAvatarButtonProps {
  vendor: {
    affiliateProgramBrandName?: string;
    avatar: string;
    email: string;
  };
  onClick: () => void;
}
export const AffiliateDashboardVendorAvatarButton = t0 => {
  const $ = _c(11);
  const {
    vendor,
    onClick
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const t1 = vendor.affiliateProgramBrandName ?? vendor.email;
  let t2;
  if ($[0] !== t || $[1] !== t1) {
    t2 = t("dashboard.affiliate_dashboard.filter_by_vendor", {
      vendor: t1
    });
    $[0] = t;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== vendor.affiliateProgramBrandName || $[4] !== vendor.avatar || $[5] !== vendor.email) {
    t3 = <Avatar size="md" alt="" src={vendor.avatar} displayName={vendor.affiliateProgramBrandName} email={vendor.email} />;
    $[3] = vendor.affiliateProgramBrandName;
    $[4] = vendor.avatar;
    $[5] = vendor.email;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onClick || $[8] !== t2 || $[9] !== t3) {
    t4 = <button type="button" aria-label={t2} onClick={onClick} className="focus-visible:focus-ring-primary shrink-0 rounded-full outline-hidden">{t3}</button>;
    $[7] = onClick;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};